module.exports = __webpack_public_path__ + "img/item-10.659dea40.png";